import { Injectable } from "@angular/core";
import { LogoTypeEnum } from "../../edit-template.dto";
import { IBrandingDto } from "app/main/pages/settings/branding/branding.dto";
import { BrandingService } from "app/main/pages/settings/branding/branding.service";

@Injectable({
    providedIn: 'root'
})

export class EFormBrandingService {
    constructor(private brandingService:BrandingService) { }
    setLogoType(logo_type: LogoTypeEnum, branding: IBrandingDto) {
        if(!branding){
            return '';
        }
        let branding_logo_type = '';
        switch (logo_type) {
            case LogoTypeEnum.primary:
                branding_logo_type = this.brandingService.getBrandingImagesPath(branding.logo, branding.id);
                break;
            case LogoTypeEnum.secondary:
                branding_logo_type = this.brandingService.getBrandingImagesPath(branding.secondary_logo, branding.id);
                break;
            case LogoTypeEnum.no_logotype:
                branding_logo_type = '../../../../assets/images/addons-images/no-image.png';
                break;
        }
        return branding_logo_type;
    }
}